import Global from "./general/global";
import Nav from "./general/nav";
import Search from "./general/search";
import Home from "./pages/home";
import Show from './pages/show';
import Subscribe from "./pages/subscribe";
import Properties from "./pages/properties";
import Property from "./pages/property";
import Contact from "./pages/contact";


new Global();
new Nav();
new Search();
new Home();
new Show();
new Subscribe();
new Properties();
new Property();
new Contact();
